<div class="header">
    <h2>{{ 'packages.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="packages-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'packages.error.unavailable' | translate" />
} @else if (package(); as pkg) {
    <div class="body">
        <div class="entity-header">
            @if (pkg.thumbnailMediaId) {
                <div class="thumb">
                    <app-media-image [mediaId]="pkg.thumbnailMediaId" />
                </div>
            } @else {
                <div class="thumb placeholder">
                    <i class="pi pi-box"></i>
                </div>
            }
            <div class="entity-identity">
                <h1>{{ pkg.name }}</h1>
                <div class="tags">
                    <p-tag [value]="availabilityLabel(pkg.availabilityType)" [severity]="pkg.availabilityType === 'general' ? 'success' : 'warn'" />
                    @if (pkg.archivedAt) {
                        <p-tag [value]="'packages.status.archived' | translate" severity="secondary" />
                    } @else {
                        <p-tag [value]="'packages.status.active' | translate" severity="info" />
                    }
                </div>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'packages.fieldset.basic' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'packages.form.name' | translate }}</span>
                <span class="value">{{ pkg.name }}</span>
            </div>
            @if (pkg.description) {
                <div class="field">
                    <span class="label">{{ 'packages.form.description' | translate }}</span>
                    <span class="value pre">{{ pkg.description }}</span>
                </div>
            }
            <div class="field">
                <span class="label">{{ 'packages.form.availability' | translate }}</span>
                <span class="value">{{ availabilityLabel(pkg.availabilityType) }}</span>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'packages.form.courses' | translate }}</h2>
            <app-entity-list [ids]="pkg.courseIds" type="course" emptyKey="packages.courses.empty" />
        </div>

        <div class="section">
            <h2>{{ 'packages.form.pathways' | translate }}</h2>
            <app-entity-list [ids]="pkg.pathwayIds" type="predefined-pathway" emptyKey="packages.pathways.empty" />
        </div>

        @if (pkg.availabilityType === 'restricted') {
            <div class="section">
                <h2>{{ 'packages.form.schools' | translate }}</h2>
                <app-entity-list [ids]="pkg.assignedSchoolIds" type="school" emptyKey="packages.schools.empty" />
            </div>
        }
    </div>

    <div class="footer">
        <app-package-delete-button
            [packageId]="pkg.id"
            [saving]="saving()"
            [disabled]="pkg.availabilityType === 'restricted' && pkg.assignedSchoolIds.length > 0"
            testId="packages-view-delete"
        />
        <p-button
            [label]="(pkg.archivedAt ? 'packages.detail.unarchive' : 'packages.detail.archive') | translate"
            [icon]="pkg.archivedAt ? 'pi pi-replay' : 'pi pi-box'"
            severity="warn"
            [outlined]="true"
            [loading]="saving()"
            data-test="packages-view-archive-toggle"
            (onClick)="onArchiveToggle(pkg.id, !!pkg.archivedAt)"
        />
        <p-button [label]="'packages.detail.edit' | translate" icon="pi pi-pencil" data-test="packages-view-edit" (onClick)="onEdit(pkg.id)" />
    </div>
}
